import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { awsInstance } from "../../actions/api";
import { useRecoilState, useRecoilValue } from "recoil";
import { userState, indicatorState } from "../../stores/atoms";
import EmployeeListItem from "./EmployeeListItem";
import Loading from './../Loading';

function Employee() {
  const [, setIndicator] = useRecoilState(indicatorState);
  const user = useRecoilValue(userState);
  const link = useHistory();
  const [groupId, setGroupId] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [department, setDepartment] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setIndicator("홈 > 직원 관리");
    onSearchClick();

    const getGroupList = async () => {
      try {
        const { data } = await awsInstance.get("/business/group-list", {
          params: {
            id: user.company_id
          },
        });
        if (data.code === "SUCCESS") {
          setGroupList(data.data);
        }
      } catch (e) {
        alert(e);
      }
    };
    getGroupList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onRegisgerEmployee = () => {
    link.push(`/employee-register`);
  };

  const checkboxes = document.getElementsByClassName("checkbox");
  const onCheckAll = (event) => {
    const isChecked = event.target.checked;
    for (let checkbox of checkboxes) {
      checkbox.checked = isChecked;
    }
  };

  const onChangeCheckbox = () => {
    const allCheckbox = document.getElementById("select-all");
    let count = 0;
    for (let checkbox of checkboxes) {
     if(checkbox.checked){
       count++;
     }
     if(count === employeeList.length) {
      allCheckbox.checked = true;
    } else {
       allCheckbox.checked = false;
     }
    }
  }
  
  const onDeleteEmployee = async () => {
    const employeeArr = [];
    for (let checkbox of checkboxes) {
      if (checkbox.checked) {
        employeeArr.push(checkbox.value);
      }
    }
    const employeeIds = employeeArr.join();
    if (!employeeIds) {
      alert("삭제할 직원을 선택해주세요.");
      return false;
    }
    if (window.confirm("해당 직원을 삭제하시겠습니까?")) {
      const selectedList = employeeList.filter((employee) => {
        return employeeArr.indexOf(employee.id.toString()) > -1;
      });
      if (hasAdmin(selectedList)) {
        alert("관리자는 삭제할 수 없습니다.");
        return;
      }
      try {
        setLoading(true);
        const params = new URLSearchParams({
          ids: employeeIds
        });
        const { data } = await awsInstance.delete(
          `/business/employee?${params}`
        );
        if (data.code === "SUCCESS") {
          setEmployeeList(
            employeeList.filter((employee) => {
              return !employeeIds.includes(employee.id);
            })
          );
        } else {
          alert(data.message);
        }
      } catch (e) {
        alert(e);
      } finally {
        setLoading(false);
      }
    } else {
      return false;
    }
  };

  const hasAdmin = (list) => {
    for (const employee of list) {
      if (employee.authorized === 1) {
        return true;
      }
    }
    return false;
  };

  const onKeyUp = (e) => {
    if (e.keyCode === 13) {
      onSearchClick();
    }
  };

  const onSearchClick = async () => {
    try {
      setLoading(true);
      const { data } = await awsInstance.get("/business/employee-list", {
        params: {
          company_id: user.company_id,
          group_id: groupId,
          name: name,
          email: email,
          department: department
        },
      });
      if (data.code === "SUCCESS") {
        setEmployeeList(data.data);
      } else {
        setEmployeeList([]);
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <div className="employee" style={{ minWidth: "fit-content" }}>
      <h5 className="title">직원 관리</h5>
      <p className="txt-gray">
        직원 ID를 클릭하면 직원 정보 수정이 가능합니다.
      </p>
      <div className="d-flex justify-content-between border-top-gray border-bottom-gray pt-3 pb-3">
        <div className="d-flex align-items-center mr-1">
          <span className="txt-dark-gray mr-1" style={{ minWidth: "2rem" }}>
            그룹
          </span>
          <select
            className="form-control font-bold"
            style={{ minWidth: "10rem" }}
            value={groupId}
            onChange={(e) => setGroupId(e.target.value)}
          >
            <option value="" className="font-bold">
              모두
            </option>
            {groupList.map((group) => {
              return (
                <option value={group.id} key={group.id} className="font-bold">
                  {group.name}
                </option>
              );
            })}
          </select>
        </div>
        <div className="d-flex align-items-center mr-1">
          <span
            className="txt-dark-gray font-bold mr-1"
            style={{ minWidth: "2rem" }}
          >
            이름
          </span>
          <input
            className="form-control"
            style={{ minWidth: "10rem" }}
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyUp={onKeyUp}
          />
        </div>
        <div className="d-flex align-items-center mr-1">
          <span
            className="txt-dark-gray font-bold mr-1"
            style={{ minWidth: "3rem" }}
          >
            이메일
          </span>
          <input
            className="form-control"
            style={{ minWidth: "10rem" }}
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyUp={onKeyUp}
          />
        </div>
        <div className="d-flex align-items-center mr-1">
          <span
            className="txt-dark-gray font-bold mr-1"
            style={{ minWidth: "2rem" }}
          >
            부서
          </span>
          <input
            className="form-control"
            style={{ minWidth: "10rem" }}
            type="text"
            value={department}
            onChange={(e) => setDepartment(e.target.value)}
            onKeyUp={onKeyUp}
          />
        </div>
        <div className="d-flex align-items-center mr-1">
          <button
            className="btn-dark-sm"
            style={{ minWidth: "5rem" }}
            onClick={onSearchClick}
          >
            검색
          </button>
        </div>
      </div>

      <div className="display-flex justify-content-between align-items-center">
        <p className="txt-gray mt-3 font-bold">
          <span className="txt-blue">{employeeList.length}건</span>이
          검색되었습니다.
        </p>
        <div>
          <button
            className="btn-blue-md mr-2 pt-1 pb-1"
            onClick={onRegisgerEmployee}
          >
            직원 등록
          </button>
          <button className="btn-white-md pt-1 pb-1" onClick={onDeleteEmployee}>
            직원 삭제
          </button>
        </div>
      </div>
      <table className="table table-hover table-list">
        <tbody>
          <tr className="background-gray txt-white">
            <th className="width-30">
              <input
                className="float-left"
                id="select-all"
                type="checkbox"
                name="check"
                value="0"
                onChange={onCheckAll}
              />
              <span className="txt-center">이메일</span>
            </th>
            <th className="width-8">이름</th>
            <th className="width-20">휴대폰 번호</th>
            <th className="width-12">부서</th>
            <th className="width-12">그룹</th>
            <th className="width-12">상태</th>
          </tr>
          {employeeList.length !== 0 &&
            employeeList.map((employee) => {
              return (
                <EmployeeListItem
                  key={employee.id}
                  employee={employee}
                  onChangeCheckbox={onChangeCheckbox}
                />
              );
            })}
          {employeeList.length === 0 && (
            <>
              <tr>
                <th colSpan="6">
                  <span className="txt-dark-gray">등록된 직원이 없습니다.</span>
                </th>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </div>
      <Loading loading={loading} />
      </>
  );
}

export default Employee;
